import { LocalStorageService } from './../../../../../core/services/local-storage.service';
import { ContactService } from './../../../../../core/services/contact/contact.service';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import {
  emailSended,
  serverError,
} from './../../../../../core/models/messages';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ReCaptchaService } from '@shared/services/reCaptcha.service';

@Component({
  selector: 'app-contacter',
  templateUrl: './contacter.component.html',
  styleUrls: ['./contacter.component.css'],
})
export class ContacterComponent {
  contactForm!: FormGroup;
  currentUser: any;
  id: any;
  filtered: any;
  submitted = false;
  types = [
    { value: 'Technique', id: '1' },
    { value: 'Service client', id: '2' },
    { value: 'Réclamation', id: '3' },
  ];
  selected: any = this.types[0];
  file: any;
  constructor(
    private contactService: ContactService,
    private spinner: NgxSpinnerService,
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private localStorageService: LocalStorageService,
    private reCaptchaService: ReCaptchaService,
  ) {}

  ngOnInit() {
    let id = this.localStorageService.getData('clientConnected');
    this.contactFormGroup();
    console.log(this.contactFormGroup());
    this.id = this.activatedRoute.snapshot.params['id'];
  }

  contactFormGroup() {
    this.contactForm = this.formBuilder.group({
      type: [null],
      object: ['', Validators.required],
      subject: ['', Validators.required],
      user_id: [''],
      file: [''],
    });
  }

  onFileChange(event: Event) {
    const fileInput = event.target as HTMLInputElement;
    if (fileInput.files && fileInput.files[0]) {
      const file = fileInput.files[0];
      this.file = file;
      this.contactForm.get('file')?.setValue(this.file);
    }
  }

  contactWegestU() {
    // stop here if form is invalid
    if (this.contactForm.invalid) {
      return;
    }

    this.reCaptchaService.executeAction('contact').then(token => {
      this.contactForm.get('user_id')?.setValue(this.id);
      this.spinner.show();
      this.submitted = true;
      const formData = new FormData();
      formData.append('recaptchaToken', token);
      formData.append('type', this.contactForm.get('type')?.value);
      formData.append('object', this.contactForm.get('object')?.value);
      formData.append('subject', this.contactForm.get('subject')?.value);
      formData.append('user_id', this.id);
      formData.append('file', this.file);
      const formDataObject: { [key: string]: any } = {};
      formData.forEach((value, key) => {
        formDataObject[key] = value;
      });
      console.log('formDataObject++', formDataObject);
      this.contactService
        .contactWegestU(formData)
        .pipe()
        .subscribe({
          next: (res) => {
            this.toastrService.success(emailSended);
            this.onReset();
            this.spinner.hide();
          },
          error: (err) => {
            this.spinner.hide();
            if (err?.error) {
              this.toastrService.error(serverError);
            }
          },
        });
        }).catch(err => {
          this.spinner.hide();
          this.toastrService.error('reCAPTCHA verification failed. Please try again.');
        });
  }

  get f() {
    return this.contactForm.controls;
  }

  onSelectChange(event: any) {
    console.log('Selected:', event);
  }

  onReset() {
    this.submitted = false;
    this.contactForm.reset({
      type: [this.types[1].id],
      user_id: this.id,
      // file:''
    });
    this.contactForm.get('file')?.setValue('');
  }
}
